// extracted by mini-css-extract-plugin
module.exports = {"provide-requested-documents-modal-trigger":"style_provide-requested-documents-modal-trigger__LDzaK"};